import type { ReactNode } from 'react';
import { useSilobagListContext } from '../../context';
import type { SilobagTab, SilosProTab } from '../../hook/use-silobag-list-logic-state';
import { EXPLORER } from './silobag-list-explorers';

type ExplorerByState = Record<'silospro' | 'silobag', Record<SilosProTab | SilobagTab, ReactNode>>;

export function Explorer() {
  const {
    state: { current },
  } = useSilobagListContext();

  const EXPLORER_BY_STATE = {
    silospro: {
      vrr: <EXPLORER.SILOS_PRO.VRR />,
      'no-vrr': <EXPLORER.SILOS_PRO.WITHOUT_VRR />,
      closed: <EXPLORER.SILOS_PRO.CLOSED />,
    },
    silobag: {
      active: <EXPLORER.SILOBAG.ACTIVE />,
      closed: <EXPLORER.SILOBAG.CLOSED />,
      archived: <EXPLORER.SILOBAG.ARCHIVED />,
    },
  } as ExplorerByState;

  return EXPLORER_BY_STATE[current.view][current.tab] ?? null;
}
